import React from 'react';
import { Filter, Smartphone, Monitor } from 'lucide-react';
import { Card, CardContent } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/table';
import { ACTION_CONFIG, formatRelativeTime, getDeviceType } from './activityUtils';
import { LocationText } from './LocationText';

export const ActivityLogTab = ({ activities, filterAction, onFilterChange, onSelectUser }) => (
  <>
    <div className="flex items-center gap-3 mb-4">
      <Filter size={16} className="text-gray-500" />
      <Select value={filterAction} onValueChange={onFilterChange}>
        <SelectTrigger className="w-[220px] bg-gray-900 border-gray-700 text-white" data-testid="activity-filter">
          <SelectValue placeholder="Filtrar por accion" />
        </SelectTrigger>
        <SelectContent className="bg-gray-900 border-gray-700">
          <SelectItem value="all" className="text-white hover:bg-gray-800">Todas las acciones</SelectItem>
          <SelectItem value="login" className="text-white hover:bg-gray-800">Inicios de Sesion</SelectItem>
          <SelectItem value="register" className="text-white hover:bg-gray-800">Nuevos Registros</SelectItem>
          <SelectItem value="recommendation" className="text-white hover:bg-gray-800">Recomendaciones</SelectItem>
          <SelectItem value="super_ia" className="text-white hover:bg-gray-800">Sócrates</SelectItem>
          <SelectItem value="bot_diario" className="text-white hover:bg-gray-800">Bot Diario</SelectItem>
        </SelectContent>
      </Select>
    </div>
    <Card className="bg-gray-900 border-gray-800" data-testid="activity-log-card">
      <CardContent className="p-0">
        <Table>
          <TableHeader>
            <TableRow className="border-gray-800 hover:bg-transparent">
              <TableHead className="text-gray-400">Usuario</TableHead>
              <TableHead className="text-gray-400">Accion</TableHead>
              <TableHead className="text-gray-400">Detalles</TableHead>
              <TableHead className="text-gray-400">Ubicacion</TableHead>
              <TableHead className="text-gray-400">Dispositivo</TableHead>
              <TableHead className="text-gray-400">Fecha</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {activities.length === 0 ? (
              <TableRow>
                <TableCell colSpan={6} className="text-center text-gray-500 py-12">
                  No hay actividad registrada
                </TableCell>
              </TableRow>
            ) : (
              activities.map((a) => {
                const config = ACTION_CONFIG[a.action] || ACTION_CONFIG.login;
                const Icon = config.icon;
                const device = getDeviceType(a.user_agent);
                return (
                  <TableRow key={a.id} className="border-gray-800 hover:bg-gray-800/50 cursor-pointer" onClick={() => onSelectUser(a.user_id)} data-testid={`activity-row-${a.id}`}>
                    <TableCell>
                      <div className="flex items-center gap-2.5">
                        <div className="w-8 h-8 rounded-full bg-gray-800 flex items-center justify-center">
                          <span className="text-white text-xs font-bold">
                            {a.user_name?.charAt(0)?.toUpperCase() || a.user_email?.charAt(0)?.toUpperCase() || '?'}
                          </span>
                        </div>
                        <div>
                          <p className="text-white text-sm font-medium truncate max-w-[150px]">{a.user_name || '-'}</p>
                          <p className="text-gray-600 text-[11px] truncate max-w-[150px]">{a.user_email}</p>
                        </div>
                      </div>
                    </TableCell>
                    <TableCell>
                      <Badge className={`${config.bg} ${config.color} border-0 gap-1`}>
                        <Icon size={12} />
                        {config.label}
                      </Badge>
                    </TableCell>
                    <TableCell>
                      {a.details?.lottery_name && <span className="text-gray-400 text-sm">{a.details.lottery_name}</span>}
                      {a.details?.numbers && (
                        <div className="flex gap-1 mt-0.5">
                          {a.details.numbers.map((n, i) => (
                            <span key={`n-${i}`} className="w-6 h-6 rounded-full bg-green-500/20 text-green-400 flex items-center justify-center text-[10px] font-bold">{n}</span>
                          ))}
                        </div>
                      )}
                      {a.details?.strategy && <span className="text-gray-500 text-xs">Estrategia: {a.details.strategy}</span>}
                      {!a.details?.lottery_name && !a.details?.numbers && <span className="text-gray-600 text-xs">-</span>}
                    </TableCell>
                    <TableCell>
                      <LocationText location={a.location} />
                      {a.ip_address && <p className="text-gray-600 text-[10px] mt-0.5">{a.ip_address}</p>}
                    </TableCell>
                    <TableCell>
                      {device === 'mobile' ? <Smartphone size={16} className="text-gray-500" /> : <Monitor size={16} className="text-gray-500" />}
                    </TableCell>
                    <TableCell className="text-gray-400 text-sm whitespace-nowrap">
                      {formatRelativeTime(a.created_at)}
                    </TableCell>
                  </TableRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  </>
);
